import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllBranches } from "../../redux/action/branchActions";
import SmartTable from "../../components/common/SmartTable";
import DeleteModal from "../../components/common/Modals/DeleteModal";
import AddCommonAction from "../../components/common/Actions/AddCommonAction";
import EditCommonAction from "../../components/common/Actions/EditAction";
import DeleteCommonAction from "../../components/common/Actions/DeleteCommonAction";
import IconCommonAction from "../../components/common/Actions/IconCommonAction";

import { getAllRestaurants } from "../../redux/action/restaurantActions";
import ScheduleBookingModal from "../../components/common/Modals/ScheduleBookingModal";
import TableTitle from "../../components/common/SmartTable/TableTitle";
import ScheduleCalendar from "../../components/common/Booking/ScheduleCalendar";
import CommonAddModal from "../../components/common/Modals/CommonAddModal";
import { mobileRegex } from "../../helpers/regex";
import moment from "moment";
import {
  createBooking,
  getAllBookings,
  updateBooking,
} from "../../redux/action/bookingActions";
import { getAllTables } from "../../redux/action/tableActions";
import { getBranchItems } from "../../redux/action/itemActions";
import { BOOKINGSTATUS, DATEFORMAT, DATETIMEFORMAT } from "../../contants";
import buildWhatsAppMessage from "../../helpers/whatsappMessageBuilder";

const PageTitle = "Bookings";

const ManageBranches = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState();
  const [actionData, setActionData] = React.useState();

  const { role, restaurantId, branchId, currentBranches, allowedBranches, name: restaurantName, mobile: restaurantMobile } =
    useSelector((state) => state.user);
  const {
    allBranches: branches,
    tables,
    items,
  } = useSelector((state) => state.branch);

  const isRestaurantAdmin = role === "restaurantadmin";

  const [selectedBranch, setSelectedBranch] = React.useState(branchId || "all");
  const [dates, setDates] = React.useState({
    start: moment().startOf("month").toDate(),
    end: moment().endOf("month").add(1, "minute").toDate(),
  });

  const { bookings } = useSelector((state) => state.common);

  const currentBranchId = branchId || selectedBranch || branches[0]?._id;
  function valid(current) {
    return current.isAfter(moment().subtract("1", "day"));
  }

  const isCanceledBooking = actionData?.bookingStatus === BOOKINGSTATUS[2].key;

  const formData = [
    {
      hidden: !isRestaurantAdmin,
      type: "select",
      size: 12,

      name: "branchId",
      label: "Choose Branch",
      readOnly: open === "Edit",
      defaultOption: () => (
        <option disabled selected>
          Choose Branch
        </option>
      ),
      optionLabelProp: "branchName",
      optionValueProp: "_id",
      hasOptions: true,
      required: true,
      onSelect: (value) => {
        dispatch(getAllTables(restaurantId, value));
        dispatch(getBranchItems(value));
      },
    },

    {
      type: "text",
      name: "eventName",
      label: "Event Name / Occasion (પ્રસંગ)",
      readOnly: open === "Edit",

      placeholder: "e.g. લગ્ન, Birthday Party, Corporate Event",
      required: true,
      size: 12,
      rules: {
        required: {
          value: true,
          message: "Event Name is required",
        },
      },
    },
    {
      type: "multiSelect",
      size: 12,

      name: "tables",
      label: "Choose Tables",
      optionLabelProp: "tableNumber",
      optionValueProp: "_id",
      hasOptions: true,
    },
    {
      type: "customerMobileAutocomplete",
      name: "contactNumber",
      nameFieldName: "hostedBy",
      label: "Contact Mobile Number",
      size: 6,

      placeholder: "Enter a Contact Mobile Number",
      required: true,
      rules: {
        required: {
          value: true,
          message: "Contact Mobile Number is required",
        },
        pattern: {
          value: mobileRegex,
          message: "Invalid Mobile Number",
        },
      },
    },
    {
      type: "text",
      name: "hostedBy",
      label: "Hosted By",


      placeholder: "Type Host Name",
      required: true,
      size: 6,
      rules: {
        required: {
          value: true,
          message: "Host name is required",
        },
      },
    },
    {
      type: "dateTime",
      name: "start",
      size: 6,
      label: "Event Start Date & Time",
      placeholder: "Event Start Date & Time",
      required: true,
      options: {
        isValidDate: valid,
      },
      rules: {
        required: {
          value: true,
          message: "Start Date & time is required",
        },
      },
    },
    {
      type: "dateTime",
      name: "end",
      size: 6,
      label: "Event End Date & Time",
      placeholder: "Event End Date & Time",
      required: true,
      options: {
        isValidDate: valid,
      },
      rules: {
        required: {
          value: true,
          message: "End Date & time is required",
        },
      },
    },
    {
      type: "multiSelect",
      size: 12,
      defaultOption: () => (
        <option disabled selected>
          Choose Itens
        </option>
      ),
      name: "items",
      label: "Choose Items",
      optionLabelProp: "itemName",
      optionValueProp: "_id",
      hasOptions: true,
      appendTo: "menuDetails",
    },
    {
      type: "creatableTags",
      name: "menuDetails",
      label: "Menu Details (મેનૂ)",
      placeholder: "e.g. ચા, નાસ્તો, ભોજન, મીઠાઈ...",
      size: 12,
    },
    {
      type: "number",
      name: "numberOfPersons",
      label: "Number of Guests (મહેમાનોની સંખ્યા)",
      placeholder: "e.g. 200",
      size: 12,
      required: true,
      min: 0,
      rules: {
        required: {
          value: true,
          message: "Number of Guests is required",
        },
      },
    },
    {
      type: "number",
      name: "totalAmount",
      label: "Total Amount / કુલ રકમ (₹)",
      placeholder: "e.g. 50000",
      size: 6,
      noSpinner: true,
      className: "no-spinner",
      min: 0,
    },
    {
      type: "number",
      name: "advanceAmount",
      label: "Advance Received / એડવાન્સ (₹)",
      placeholder: "e.g. 20000",
      size: 6,
      noSpinner: true,
      className: "no-spinner",
      min: 0,
    },
    {
      type: "switch",
      name: "decorationIncluded",
      label: "Decoration Included? (ડેકોરેશન શામેલ)",
      size: 7,
    },

    {
      type: "textarea",
      name: "remarks",
      label: "Remarks",
      size: 12,
      placeholder: "Type Remarks",
    },
  ];

  const toggleAdd = (mode) => {
    setOpen(mode);
    if (mode === undefined) {
      setActionData({});
    }
  };
  const handleAdd = (data) => {
    setActionData(data);

    toggleAdd("Add");
  };
  const handleEdit = (data) => {
    if (data?.bookingStatus === BOOKINGSTATUS[2].key) {
      toggleAdd("View");
    } else {
      toggleAdd("Edit");
    }
    setActionData({
      ...data,
      start: moment(data.start).toDate(),
      end: moment(data.end).toDate(),
    });
  };
  const handleDelete = (data) => {
    toggleAdd("Delete");
    setActionData(data);
  };

  const handleSchedule = (data) => {
    toggleAdd("schedule");
    setActionData(data);
  };

  const onRangeChange = (e) => {
    if (Array.isArray(e)) {
      if (e.length === 1) {
        setDates({
          start: moment(e[0]).startOf("day").toDate(),
          end: moment(e[0]).endOf("day").add(1, "minute").toDate(),
        });
      }
      if (e.length > 1) {
        setDates({
          start: e[0],
          end: e[6],
        });
      }
    } else {
      setDates({
        start: e.start,
        end: e.end,
      });
    }

    // if (e?.start && e?.end) {
    //   dispatch(
    //     getAllBookings({
    //       branchId: currentBranchId,
    //       restaurantId,
    //       start: e.start,
    //       end: e.end,
    //     })
    //   );
    // }
    // if (Array.isArray(e)) {
    //   if (e.length > 5) {
    //     dispatch(
    //       getAllBookings({
    //         branchId: currentBranchId,
    //         restaurantId,
    //         start: e[0],
    //         end: e[6],
    //       })
    //     );
    //   }
    //   if (e.length === 1) {
    //     dispatch(
    //       getAllBookings({
    //         branchId: currentBranchId,
    //         restaurantId,
    //         start: e[0],
    //       })
    //     );
    //   }
    // }
  };

  const onAdd = (data) => {
    const pendingAmount =
      (Number(data.totalAmount) || 0) - (Number(data.advanceAmount) || 0);

    if (open === "Add") {
      dispatch(
        createBooking(
          {
            ...data,
            pendingAmount,
            branchId: currentBranchId,

            bookingStatus: BOOKINGSTATUS[0].key,
          },
          () => {
            toggleAdd();
            getData();
          },
          []
        )
      );
    }
    if (open === "Edit") {
      let editData = {
        ...actionData,
        ...data,
        pendingAmount,
        branchId: currentBranchId,
      };

      dispatch(
        updateBooking(editData, () => {
          toggleAdd();
          getData();
        })
      );
    }
  };

  const onCancelBooking = () => {
    let editData = {
      ...actionData,
      bookingStatus: BOOKINGSTATUS[2].key,
    };

    dispatch(
      updateBooking(editData, () => {
        toggleAdd();
        getData();
      })
    );
  };

  const AddAction = () => {
    return (
      <AddCommonAction
        onClick={() => handleAdd(defaultValues)}
        title={PageTitle}
      />
    );
  };

  const CancelAction = ({ data }) => {
    return (
      <button
        type="submit"
        className="btn btn-outline-danger waves-effect waves-light ml-3"
        onClick={() => handleDelete(data)}
      >
        Cancle Booking
      </button>
    );
  };

  // WhatsApp Button
  const WhatsAppAction = ({ data }) => {
    const currentBranch = branches.find(
      (b) => b._id === (data?.branchId || currentBranchId)
    );
    const branchName = currentBranch?.branchName;
    const restaurantAddress =
      currentBranch?.address || currentBranch?.branchAddress || "";

    const handleSendWhatsApp = () => {
      const message = buildWhatsAppMessage({
        booking: data,
        branchName: branchName,
        restaurantName: restaurantName,
        restaurantMobile: restaurantMobile,
        restaurantAddress: restaurantAddress,
      });

      const phoneNumber = data?.contactNumber
        ? String(data.contactNumber).replace(/\D/g, "")
        : "";
      const fullPhone = phoneNumber.startsWith("91")
        ? phoneNumber
        : `91${phoneNumber}`;

      const url = `https://api.whatsapp.com/send?phone=${fullPhone}&text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");
    };

    return (
      <button
        type="button"
        className="btn waves-effect waves-light ml-3"
        style={{
          backgroundColor: "#25D366",
          color: "#fff",
          border: "none",
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          fontWeight: 600,
        }}
        onClick={handleSendWhatsApp}
        title="Send booking confirmation on WhatsApp"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="white"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>

      </button>
    );
  };

  const headers = [
    { title: "Booking Space name", key: "bookingSpace" },
    { title: "Associated With", key: "branchName" },

    // { title: "Total Items", key: "itemCount" },
    { title: "Status", key: "status" },
  ];

  const BranchFilter = (action) => (
    <div className="">
      <select
        name="status"
        className="form-control"
        defaultValue="true"
        required
        value={selectedBranch}
        onChange={(e) => setSelectedBranch(e.target.value)}
      >
        <option value={"all"}>All Branches</option>
        {branches.map((res, resindex) => {
          return (
            <option key={resindex} value={res._id}>
              {res.branchName}
            </option>
          );
        })}
      </select>
    </div>
  );

  const headerComponents = {
    superadmin: [],
    restaurantadmin: [BranchFilter],
  };

  const defaultValues = {
    restaurantId: restaurantId,
    // start: moment().toDate(),
    // end: moment().toDate(),
  };
  React.useEffect(() => {
    dispatch(getAllBranches(restaurantId));

    dispatch(getAllTables(restaurantId, currentBranchId));
    dispatch(getBranchItems(currentBranchId));
  }, [currentBranchId]);

  const getData = () => {
    dispatch(
      getAllBookings({ branchId: currentBranchId, restaurantId, ...dates })
    );
  };

  React.useEffect(() => {
    getData();
  }, [dates]);

  return (
    <div className="page-content-tab">
      <DeleteModal
        size="md"
        open={open === "Delete"}
        title={actionData?.title}
        preTitle="Are you sure you want to cancel"
        onClose={() => toggleAdd()}
        onConfirm={() => onCancelBooking()}
      />
      <CommonAddModal
        title={PageTitle}
        open={open === "Add" || open === "Edit" || open === "View"}
        onClose={() => toggleAdd()}
        mode={open}
        onSubmit={(e) => onAdd(e)}
        data={actionData}
        formData={formData}
        defaultValues={defaultValues}
        size="md"
        optionsData={{
          tables: tables,
          branchId: branches,
          items: items,
        }}
        hideSubmit={isRestaurantAdmin || isCanceledBooking}
        extraButtons={
          isRestaurantAdmin
            ? isCanceledBooking ? [] : [WhatsAppAction]
            : open === "Edit" && !isCanceledBooking
              ? [CancelAction, WhatsAppAction]
              : open === "View" && !isCanceledBooking
                ? [WhatsAppAction]
                : []
        }
      />
      <div className="row">
        <div className="col-12">
          <div className={"card"}>
            <div className={"card-body"}>
              <TableTitle
                headerComponents={headerComponents[role]}
                title={PageTitle}
                endActions={[AddAction]}
              />
              <ScheduleCalendar
                events={
                  bookings
                    ? bookings?.map((d) => {
                      return { ...d, title: d.eventName };
                    })
                    : []
                }
                handleSelect={(data) => handleEdit(data)}
                onRangeChange={(data) => onRangeChange(data)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageBranches;
